import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { useAuth } from '../Context/Auth';
import axios from '../Config/axiosConfig';
import './Feedback.css';

const api = `${process.env.REACT_APP_API_URL}/api/Feedback`;
export default function FeedbackPrompt() {
  const { currentUser, isClient } = useAuth();
  const [campanha, setCampanha] = useState(null); const [mostrar, setMostrar] = useState(false);
  const [nota, setNota] = useState(0); const [hover, setHover] = useState(0); const [comentario, setComentario] = useState('');
  const [enviando, setEnviando] = useState(false); const [erro, setErro] = useState(''); const timer = useRef();
  const [agradecimento, setAgradecimento] = useState(false);
  const token = currentUser?.token;
  useEffect(() => {
    if (!isClient || !token) return undefined;
    let cancelado = false;
    axios.get(`${api}/current`).then(response => {
      if (!cancelado && response.data.shouldShow) {
        setCampanha(response.data);
        timer.current = setTimeout(() => !cancelado && setMostrar(true), response.data.atrasoExibicaoSegundos * 1000);
      }
    }).catch(() => console.warn('Não foi possível consultar a avaliação atual.'));
    return () => { cancelado = true; clearTimeout(timer.current); };
  }, [isClient, token]);
  const agir = async (acao) => {
    if (!campanha || enviando || (acao === 'submit' && !nota)) { if (!nota && acao === 'submit') setErro('Selecione de 1 a 5 estrelas.'); return; }
    setEnviando(true); setErro('');
    try {
      const body = acao === 'submit' ? { rating: nota, comentario } : undefined;
      await axios.post(`${api}/current/${campanha.campaignId}/${acao}`, body);
      setMostrar(false); setCampanha(null); if (acao === 'submit') { setAgradecimento(true); setTimeout(() => setAgradecimento(false), 4000); }
    } catch (error) { setErro(error.response?.data?.message || 'Não foi possível registrar sua escolha. Tente novamente.'); }
    finally { setEnviando(false); }
  };
  if (!mostrar || !campanha) return agradecimento ? <div className="feedback-agradecimento" role="status">Obrigado pela sua avaliação!</div> : null;
  return <aside className="feedback-prompt shadow" role="dialog" aria-labelledby="feedback-titulo">
    <button className="feedback-fechar" aria-label="Lembrar mais tarde e fechar" disabled={enviando} onClick={() => agir('remind-later')}>×</button>
    <h5 id="feedback-titulo">{campanha.titulo}</h5><p>{campanha.mensagem}</p>
    {erro && <Alert variant="danger" className="py-2">{erro}</Alert>}
    <div className="feedback-estrelas" role="radiogroup" aria-label="Sua nota de 1 a 5 estrelas">
      {[1, 2, 3, 4, 5].map(valor => <button key={valor} type="button" role="radio" aria-checked={nota === valor}
        aria-label={`${valor} ${valor === 1 ? 'estrela' : 'estrelas'}`} className={(hover || nota) >= valor ? 'ativa' : ''}
        onMouseEnter={() => setHover(valor)} onMouseLeave={() => setHover(0)} onFocus={() => setHover(valor)} onBlur={() => setHover(0)} onClick={() => setNota(valor)}>★</button>)}
    </div>
    <Form.Group className="mt-2"><Form.Label className="visually-hidden" htmlFor="feedback-comentario">Comentário opcional</Form.Label>
      <Form.Control id="feedback-comentario" as="textarea" rows={3} maxLength={1000} value={comentario} disabled={enviando}
        placeholder="Comentário opcional" onChange={event => setComentario(event.target.value)} /></Form.Group>
    <Button className="w-100 mt-3" size="sm" disabled={enviando || !nota} onClick={() => agir('submit')}>
      {enviando && <Spinner size="sm" className="me-2" />}Enviar avaliação</Button>
    <div className="feedback-acoes"><Button variant="link" size="sm" disabled={enviando} onClick={() => agir('remind-later')}>Lembrar mais tarde</Button>
      <Button variant="link" size="sm" disabled={enviando} onClick={() => agir('decline')}>Não quero avaliar agora</Button></div>
  </aside>;
}
